export default {
  creator: 'creator',
  leader: 'leader',
  member: 'member'
};
